<template>
    <div class="mt-2">
        <v-autocomplete
            :value="selected_company_id"
            :items="companies"
            :filter="customFilter"
            item-text="title"
            item-value="id"
            @change="switchCompany"
            @click:append="toggleCompanySwitcher=true"
            :menu-props="{'closeOnClick':true, 'closeOnContentClick':false, 'openOnClick':true, 'value':toggleCompanySwitcher}"
      >
        <template v-slot:append-item>
          <v-divider></v-divider>
          <v-btn :to="{name:'Companies'}" flat color="primary">
            <v-icon>$vuetify.icons.rms_bank</v-icon>
            <span class="pl-2">All Companies</span>
          </v-btn>
        </template>
      </v-autocomplete>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
  export default {
    props: {
      toggleCompanySwitcher: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {

      }
    },
    created() {
        this.getCompanies();
    },
    computed: {
        ...mapState({
            companies: (state) => state.company.list,
        }),
        ...mapGetters("company", {
            selected_company_id: "getSelected",
        }),
    },


    methods: {
      customFilter (item, queryText, itemText) {
        const textOne = item.title.toLowerCase()
        const searchText = queryText.toLowerCase()
        return textOne.indexOf(searchText) > -1
      },
      async getCompanies() {
          await this.$store.dispatch("company/list").then((response) => {
              this.total = response.companies.total;
          })

      },
      async switchCompany(value) {
          // console.log(value)
          await this.$store.dispatch('company/switchSelectedCompanyId',{
              id: value
          })
          .then((response) => {
              this.$router.push({
                  name: 'CompanyDashboard',
                  params: {
                    company_id: value,
                  },
              })
          })
      }
    }
  }
</script>
<style scoped>
>>> .v-input__slot::before {
  border-style: none !important;
}
</style>
